import React, { useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import SelectVerification, { VerActionType } from '@/components/SelectVerification'
import { CardActionType } from '../../index.type'

export default React.memo(function ChangeAccountSelectVerification() {
    const navigate = useNavigate()
    const { state } = useLocation()

    const scene = useMemo(() => {
        return state?.changeType === CardActionType.Google ? 'change_google_auth' : 'change_account'
    }, [state?.changeType])

    // 处理验证成功后的回调
    const handleVerificationSuccess = useCallback(({ actionType, account }: { actionType: VerActionType; account: string }) => {
        navigate('/change-account/ver-old-account-code', {
            state: {
                account,
                verification: actionType,
                ...state
            }
        })
    }, [navigate, state])

    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            <div className='px-6 py-6'>
                <SelectVerification
                    scene={scene}
                    onSuccess={handleVerificationSuccess}
                />
            </div>
        </PageLayout>
    )
})
